import { IRoute } from '../interface/interface';
import { AdminAccount } from '../pages/Admin/pages/AdminAccount';
import { AdminAddMenuArcheive } from '../pages/Admin/pages/AdminAddMenuArcheive';
import { AdminAddMenuItem } from '../pages/Admin/pages/AdminAddMenuItem';
import { AdminBookings } from '../pages/Admin/pages/AdminBookings';
import { AdminCheckIn } from '../pages/Admin/pages/AdminCheckIn';
import { AdminDashboard } from '../pages/Admin/pages/AdminDashboard';
import { AdminInvoices } from '../pages/Admin/pages/AdminInvoices';
import { AdminOnboarding } from '../pages/Admin/pages/AdminOnboarding';
import { AdminOptionsTimes } from '../pages/Admin/pages/AdminOptionsTimes';
import { AdminPriceModel } from '../pages/Admin/pages/AdminPriceModel';
import { AdminProfile } from '../pages/Admin/pages/AdminProfile';
import { AdminUpcoming } from '../pages/Admin/pages/AdminUpcoming';
import { AdminUsers } from '../pages/Admin/pages/AdminUsers';


const adminRoutes: IRoute[] = [
    {
        path: '/admin/dashboard',
        name: 'Dashboard',
        component: AdminDashboard,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/bookings',
        name: 'Bookings',
        component: AdminBookings,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/checkIn',
        name: 'Check-in',
        component: AdminCheckIn,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/upcoming',
        name: 'Upcoming',
        component: AdminUpcoming,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/addMenuItem',
        name: 'Add Menu Item',
        component: AdminAddMenuItem,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/addItemArcheive',
        name: 'Add Menu Archeive',
        component: AdminAddMenuArcheive,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/upcomingMenus',
        name: 'Upcoming Menus',
        component: AdminUpcoming,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/optionsTimes',
        name: 'Options and Times',
        component: AdminOptionsTimes,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/profile',
        name: 'Profile',
        component: AdminProfile,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/account',
        name: 'Account',
        component: AdminAccount,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/invoices',
        name: 'Invoices',
        component: AdminInvoices,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/priceModels',
        name: 'Price Models',
        component: AdminPriceModel,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/onboarding',
        name: 'Onboarding Page',
        component: AdminOnboarding,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/admin/users',
        name: 'Users',
        component: AdminUsers,
        exact: true,
        roleRequired: 'kitchen_manager_users'
    }
]

export default adminRoutes;


